export type WorkType = "drama" | "movie" | "web";

export interface Episode {
  no: number;
  title: string;
  summary: string;
  duration: string;
}

export interface Work {
  id: string;
  title: string;
  type: WorkType;
  region: string;
  year: number;
  rating: number;
  genres: string[];
  cover: string;
  heroImage?: string;
  synopsis: string;
  shortIntro: string;
  cast: string[];
  director: string;
  releaseDate: string;
  totalEpisodes: number;
  status: string;
  heat: number;
  updatedAt: string;
  episodes: Episode[];
  featured?: boolean;
  highlight: string;
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  date: string;
  author: string;
  content: string[];
}

export const TYPE_LABELS: Record<WorkType, string> = {
  drama: "电视剧",
  movie: "电影",
  web: "网剧",
};

export const TYPE_DESCRIPTIONS: Record<WorkType, string> = {
  drama: "电视剧频道，汇集最新热播剧与经典长篇佳作",
  movie: "电影频道，聚合院线新片与口碑佳作",
  web: "网剧频道，聚焦平台自制与高分短剧",
};

export const REGIONS = ["中国大陆", "中国香港", "韩国", "日本", "美国", "英国"];
export const YEARS = [2026, 2025, 2024, 2023, 2022, 2021, 2020];